import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//mui
import { Box, Button, CircularProgress, Popover, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
//components
import ConfirmationModal from './components/ConfirmationModal';
import PreviousVersions from './components/PreviousVersions';
import PropertyRoleSelect from './components/PropertyRoleSelect';
import ExportNameField from './components/ExportNameField';
//slices
import {
  toggleEditMode,
  updateViewType,
  EDIT_STATE,
  togglePropertyRole,
  toggleExportName,
  setCurrentExportId,
  bulkUpdate,
} from '../../../../store/slices/reportsSlice';
//utils
import { postReqOptBuilder } from '../../../../utils/main_utils';
//hooks
import { useExportReports } from './hooks/useExportReports';
//constants
import { PROPERTY_ROLE, ReportsCategory } from '../../../../constants';


const ViewReportHistory = ({ rid, handleNotifState }) => {
    const dispatch = useDispatch();
    const { 
        exportReport, centralizedView, availableClassifications, classifiedCategories, roomsData
    } = useSelector((state) => state.reports);
    
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const [aiGenInProgress, setAiGenInProgress] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [selectedExportId, setSelectedExportId] = useState(null);
    const [hasFetched, setHasFetched] = useState(false);
    const [exportName, setExportName] = useState('');
    const [exportRole, setExportRole] = useState(PROPERTY_ROLE.RESIDENT);

    const { fetchReports, deactivateReport, fetchReport } = useExportReports(rid, setOpenModal);
    
    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
        dispatch(togglePropertyRole(PROPERTY_ROLE.RESIDENT));
        dispatch(toggleExportName(''));
    };
    
    const handleClose = () => {
        setAnchorEl(null);
        setHasFetched(false);
    };
    
    const handleRoleChange = (event) => {
        setExportRole(event.target.value);
        // dispatch(togglePropertyRole(event.target.value));
    };
    
    const handleExportNamChange = (event) => {
        setExportName(event.target.value);
        // dispatch(toggleExportName(event.target.value));
    };
    
    const handleOpenModal = (exportId) => {
        setSelectedExportId(exportId);
        setOpenModal(true);
    };
    
    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedExportId(null);
    };

    const handleAiGenClick = (e) => setAnchorEl2(e.currentTarget);

    const handleCloseMenu = () => setAnchorEl2(null);
    
    const handleConfirmDeactivate = () => {
        if (selectedExportId) {
        deactivateReport.mutate(selectedExportId);
        }
    };
    
    const handleViewReport = (exportId) => {
        dispatch(toggleEditMode(EDIT_STATE.START));
        fetchReport.mutate(exportId);
    };
    
    const isPopoverOpen = Boolean(anchorEl);
    
    useEffect(() => {
        if (isPopoverOpen && !hasFetched) {
        fetchReports.mutate(rid);
        setHasFetched(true);
        }
    }, [isPopoverOpen, fetchReports, rid, hasFetched]);
    
    const isCreateButtonDisabled = !exportName || exportName.trim() === '';
    
    
    return (
        <>
            {/* Change View Button */}
            {availableClassifications.length > 0 &&
                <Button
                    onClick={() => dispatch(updateViewType(centralizedView ? null : ReportsCategory.CENTRALIZED))}
                    variant="contained"
                    sx={{
                        backgroundColor: 'transparent', 
                        color: '#4F46E5',
                        fontSize: '12px',
                        textTransform: 'none',
                        borderRadius: '8px',
                        height: '36px',
                        padding: '0px 12px',
                        width: 'fit-content',
                        marginTop: '6px',
                        marginRight: '12px',
                        '&:hover': {
                            color: '#4338CA',
                            backgroundColor: 'transparent'
                        } 
                    }}
                >
                    {centralizedView ? 'Original View' : 'Centralized View'}
                </Button>
            }
            {/* AI-Gen */}
            {/* <Button
                startIcon={<AutoAwesomeIcon sx={{ width: 18, height: 18, color: "#4F46E5" }} />}  
                onClick={(e) => {
                    handleAiGenClick(e);
                }}
                variant="contained"
                sx={{
                    backgroundColor: 'transparent', 
                    color: '#4F46E5',
                    fontSize: '12px',
                    textTransform: 'none',
                    borderRadius: '8px',
                    height: '36px',
                    padding: '0px 12px',
                    width: 'fit-content',
                    marginTop: '6px',
                    marginRight: '12px',
                    '&:hover': {
                        color: '#4338CA',
                        backgroundColor: 'transparent'
                    } 
                }}
            >
                {aiGenInProgress ? <CircularProgress size={20} color='inherit' /> : "AI-Generate"}
            </Button> */}

            <Menu
                anchorEl={anchorEl2}
                open={Boolean(anchorEl2)}
                onClose={handleCloseMenu}
                sx={{ mt: 1 }}
                disableScrollLock
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                disabled={aiGenInProgress}
            >
                <MenuItem
                    onClick={() => {
                        handleCloseMenu();
                        setAiGenInProgress(true);
                        fetch(
                            "https://mss.paraspot.ai/report/create_centralized_view",
                            postReqOptBuilder({rid: rid}, false)
                        )
                        .then((response) => response.json())
                        .then((response) => {
                            if (response.status === 200) {
                                handleNotifState({
                                    type: "success",
                                    message: "Rooms layout created successfully.",
                                });
                            } else {
                                handleNotifState({
                                    type: "error",
                                    message: response.message,
                                });
                            }
                            setAiGenInProgress(false);
                        })
                        .catch((error) => {
                            console.error("Error:", error);
                            handleNotifState({
                                type: "error",
                                message: "Something went wrong. Please try again later or contact support.",
                            });
                            setAiGenInProgress(false);
                        });
                    }}
                >
                    {Object.keys(classifiedCategories || {}).length === 0 ? "Create" : "Update"} Centralized Report
                </MenuItem>

                {(roomsData || []).length === 0 &&
                    <MenuItem
                        onClick={() => {
                            handleCloseMenu();
                            setAiGenInProgress(true);
                            fetch(
                                "https://mss.paraspot.ai/report/create_rooms_layout",
                                postReqOptBuilder({rid: rid}, false)
                            )
                            .then((response) => response.json())
                            .then((response) => {
                                if (response.status === 200) {
                                    handleNotifState({
                                        type: "success",
                                        message: "Rooms layout created successfully.",
                                    });
                                } else {
                                    handleNotifState({
                                        type: "error",
                                        message: response.message,
                                    });
                                }
                                setAiGenInProgress(false);
                            })
                            .catch((error) => {
                                console.error("Error:", error);
                                handleNotifState({
                                    type: "error",
                                    message: "Something went wrong. Please try again later or contact support.",
                                });
                                setAiGenInProgress(false);
                            });
                        }}
                    >
                        Create Rooms Layout
                    </MenuItem>
                }
            </Menu>

            {/* Export Button */}
            <Button
                onClick={handleOpen}
                sx={{
                    backgroundColor: '#4F46E5',
                    color: 'white',
                    fontWeight: 700,
                    fontSize: '12px',
                    width: '67px',
                    height: '36px',
                    marginTop: '6px',
                    textTransform: 'none',
                    '&:hover': {
                        backgroundColor: '#3C3EB8',
                    }
                }}
            >
                Export
            </Button>
        
            {/* Popover for "View Report History" */}
            <Popover
                open={isPopoverOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                disableScrollLock
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Box sx={{ padding: 2, width: { xs: '100%', sm: '450px' } }}>
                    {/* Create New Button */}
                    <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        sx={{
                            fontSize: '14px',
                            border: '1px solid #F2F2F3',
                            color: '#0C1222',
                            textTransform: 'none',
                            mb: 2,
                            fontWeight: 600,
                            width: '100%'
                        }}
                        onClick={() => {
                            dispatch(
                                bulkUpdate({
                                    exportName,
                                    propertyRole: exportRole,
                                    exportId: undefined,
                                    editMode: EDIT_STATE.START,
                                })
                            );
                            // dispatch(toggleExportName(exportName));
                            // dispatch(togglePropertyRole(exportRole));
                            // dispatch(setCurrentExportId(undefined));
                            // dispatch(toggleEditMode(EDIT_STATE.START));
                        }}
                        disabled={isCreateButtonDisabled}
                    >
                        Create New
                    </Button>
                    <ExportNameField exportName={exportName} handleExportNamChange={handleExportNamChange} />
                    <PropertyRoleSelect propertyRole={exportRole} handleRoleChange={handleRoleChange} />
                    <PreviousVersions
                        fetchReports={fetchReports}
                        exportReport={exportReport}
                        handleViewReport={handleViewReport}
                        handleOpenModal={handleOpenModal}
                        handleNotifState={handleNotifState}
                    />
                    <ConfirmationModal
                        open={openModal}
                        onClose={handleCloseModal}
                        onConfirm={handleConfirmDeactivate}
                        title="Delete Export"
                        description="Are you sure you want to delete this export?"
                        isLoading={deactivateReport.isLoading}
                    />
                </Box>
            </Popover>
        </>
    );
};

export default ViewReportHistory;